import constants from '../constants.js';

const CtmDebtorsTramadaIsEnabled = {
  displayName: 'Is Enabled',
  dataAt: 'TramadaDetails.IsEnabled',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const CtmDebtorsTramadaDebtorCode = {
  displayName: 'Debtor Code',
  dataAt: 'TramadaDetails.DebtorCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const CtmDebtorsTramadaInstanceId = {
  displayName: 'Instance Id',
  dataAt: 'TramadaDetails.InstanceId',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'TramadaInstances',
};

const CtmDebtorsTramadaPanel = {
  tabName: 'Tramada',
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [CtmDebtorsTramadaInstanceId, CtmDebtorsTramadaDebtorCode, CtmDebtorsTramadaIsEnabled]
};

const CtmDebtorsSabreIsEnabled = {
  displayName: 'Is Enabled',
  dataAt: 'IsEnabled',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const CtmDebtorsCurrencyCode = {
  displayName: 'Currency Code',
  dataAt: 'SabreDetails.CurrencyCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  minLength: 3,
  maxLength: 3,
  helpText: 'Must be 3 characters in length.'
};

const CtmDebtorsPCC = {
  displayName: 'PCC',
  dataAt: 'SabreDetails.Pcc',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  minLength: 4,
  maxLength: 4,
  helpText: 'Must be 4 characters in length.',
};

const CtmDebtorsSabrePanel = {
  tabName: 'Sabre',
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [CtmDebtorsPCC, CtmDebtorsCurrencyCode, CtmDebtorsSabreIsEnabled]
};

const CtmDebtorsIsEnabled = {
  displayName: 'Is Enabled',
  dataAt: 'IsEnabled',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const CtmDebtorsHomeCountry = {
  displayName: 'Home Country',
  dataAt: 'HomeCountry',
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT,
  selectType: 'single',
  required: true
};

const CtmDebtorsLogo = {
  displayName: 'Logo',
  dataAt: 'Logo',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const CtmDebtorsTitle = {
  displayName: 'Title',
  dataAt: 'Name',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const CtmDebtorsIdentifier = {
  displayName: 'Identifier',
  dataAt: 'Id',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true,
  minLength: 10,
  maxLength: 10,
  helpText: 'Must be unique and 10 characters in length.'
};

const CtmDebtorsGeneralPanel = {
  tabName: 'Info',
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [CtmDebtorsIdentifier, CtmDebtorsTitle, CtmDebtorsLogo, CtmDebtorsHomeCountry, CtmDebtorsIsEnabled]
};


const CtmDebtorsTabs = {
  displayName: 'CTM Debtor',
  displayAs: constants.DISPLAY_AS.TABS,
  children: [CtmDebtorsGeneralPanel, CtmDebtorsSabrePanel, CtmDebtorsTramadaPanel]
};

const user = JSON.parse(localStorage.getItem('oauth'));
const CtmDebtorsAddResource = {
  displayAs: constants.DISPLAY_AS.ADD_GRID_RESOURCE,
  displayName: 'CTM Debtor',
  data:
    {
      Id: '',
      Name: '',
      Logo: '',
      HomeCountry: '',
      IsEnabled: false,
      CreatedBy: user ? user['username'] : 'unknown user',
      SabreDetails: {
        CurrencyCode: '',
        Pcc: '',
        IsEnabled: false
      },
    },
  dataAt: '',
  children: [CtmDebtorsIdentifier, CtmDebtorsTitle, CtmDebtorsLogo, CtmDebtorsHomeCountry],
  microService: true,
  endpoint: constants.MICRO_SERVICE.DEBTORS,
};

const CtmDebtorsResource = {
  displayName: 'CTM Debtors',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  dataAt: '',
  children: [CtmDebtorsTabs],
  microService: true,
  endpoint: constants.MICRO_SERVICE.DEBTORS,
  iconClass: 'fa-user',
  routeParamId: 'ctmDebtorId',
};

const CtmDebtorsList = {
  rootNode: true,
  displayName: 'CTM Debtors',
  microService: true,
  endpoint: constants.MICRO_SERVICE.DEBTORS,
  iconClass: 'fa-user',
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GRID,
  gridItem: CtmDebtorsResource,
  gridAdd: CtmDebtorsAddResource,
  gridCols:
    [
      {name: 'Identifier', key: 'Id'},
      {name: 'Title', key: 'Name'},
      {name: 'Home Country', key: 'HomeCountry'},
      {name: 'Is Enabled', key: 'IsEnabled'}]
};

export default {
  CtmDebtorsList,
  CtmDebtorsResource,
  CtmDebtorsAddResource,
  // CtmDebtorsTabs,
  // CtmDebtorsGeneralPanel,
  // CtmDebtorsIdentifier,
  // CtmDebtorsTitle,
  // CtmDebtorsHomeCountry,
  // CtmDebtorsIsEnabled,
  // CtmDebtorsSabrePanel,
  // CtmDebtorsPCC,
}



// WEBPACK FOOTER //
// ./src/config/fields/ctmDebtors.js